import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18dad40a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=18dad40a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dad40a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18dad40a')) {
      api.createRecord('18dad40a', component.options)
    } else {
      api.reload('18dad40a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18dad40a&scoped=true", function () {
      api.rerender('18dad40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paymentV2/index.vue"
export default component.exports